import { getCurrentInstance } from '@vue/composition-api';

/**
 * Vue 2 compatible useRoute composable
 * Returns the current route object
 */
export function useRoute() {
  const vm = getCurrentInstance();
  if (!vm) {
    throw new Error('useRoute must be called within a setup function');
  }
  return vm.proxy.$route;
}

/**
 * Vue 2 compatible useRouter composable
 * Returns the router instance
 */
export function useRouter() {
  const vm = getCurrentInstance();
  if (!vm) {
    throw new Error('useRouter must be called within a setup function');
  }
  return vm.proxy.$router;
}
